export default __webpack_public_path__ + "static/media/accelerator.085f2d71.png";